import { render, staticRenderFns } from "./TeacherDetailsPage.vue?vue&type=template&id=65c80b05&scoped=true&"
import script from "./TeacherDetailsPage.vue?vue&type=script&lang=js&"
export * from "./TeacherDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./TeacherDetailsPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TeacherDetailsPage.vue?vue&type=style&index=1&id=65c80b05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c80b05",
  null
  
)

export default component.exports